<template>
    <div>
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryKey="queryKey" :queryHandler="queryHandler"></swb-query-sort-area>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import SwbQuerySortArea from '../query/QuerySortArea';

    Vue.regist(SwbQuerySortArea);

    let searchConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "label": "招标标题",
                "code": "title",
                "valueType": "String",
                "basic": true
            },
            {
                "type": "Text",
                "label": "招标方",
                "code": "fstPartyName",
                "basic": true,
                "valueType": "String"
            },
            {
                "type": "Text",
                "valueType": "String",
                "label": "投标人",
                "code": "applicantName",
                "basic": true
            },
            {
                "type": "Text",
                "valueType": "String",
                "label": "投标编号",
                "code": "no",
                "basic": true
            },
            {
                "type": "Date2",
                "valueType": "String",
                "label": "投标时间",
                "code": "bidTime"
            }
        ],
        "sortFields": [
            {
                "label": "投标开始时间",
                "code": "openTime",
                "order": "desc",
                "enabled": true
            },
            {
                "label": "投标截至时间",
                "code": "closeTime",
                "order": "desc",
                "enabled": true
            },
            {
                "label": "创建时间",
                "code": "createTime",
                "order": "desc",
                "enabled": true
            },
            {
                "order": "desc",
                "label": "投标时间",
                "code": "bidTime",
                "enabled": true
            },
            {
                "order": "desc",
                "label": "开标时间",
                "code": "resultPublishTime",
                "enabled": true
            }
        ]
    };

    export default {
        name: 'swb-bid-doc-search',
        desc: '报名搜索',
        data: function () {
            return {
                //排序、搜索
                queryConfig: null,
                queryKey: null,
            }
        },
        created: function () {
            //查询排序配置信息
            let queryConfig = searchConfigData || {};
            //...
            this.queryConfig = queryConfig;

            //
            let no = this.$route.query.no || null;
            let queryConfigMap = queryConfig.queryFields.toMap("code");
            if(!Utils.isNoB(no)) {
                let noItem = queryConfigMap['no'];
                noItem.value = no;
            }
        },
        methods: {
            queryHandler(queryModel) {
                this.$emit('showSearch', queryModel);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/callbid/BidDocSearchLet.vue